import createSlideshow from '../modules/slideshow/create_slideshow';
import screenSizeUtil from '../services/screen_size';
import PhotoGalleryLauncher from '../modules/photo-gallery-launcher';
import config from '../config';
import _ from 'underscore';
let $els = false;
const configForPhotoGallery = {
    isMobile: false,
    $item: '',
    slideIndex: false
};


function launchPhotoGalleries($selector, isMobile, slideIndex) {
    $selector.each((index, item) => {
        let specificConfig = _.extend({}, configForPhotoGallery);
        let $item = $(item);
        let hasAlreadyBeenInited = $item.hasClass('already-inited');

        let hasNotBeenAlreadyBeenInited = !hasAlreadyBeenInited;
        if (hasNotBeenAlreadyBeenInited) {
            $item.addClass('already-inited');
            specificConfig.$item = $item;
            specificConfig.isMobile = isMobile;
            specificConfig.slideNumberParam = slideIndex;

            let photoGalleryLauncher = new PhotoGalleryLauncher(specificConfig);
            photoGalleryLauncher.init();
        }
    });
}


export default function (slideIndex, backbutton) {
    if (config.get('featureFlags.mobilePhotoGallery') === true) {
        if (screenSizeUtil.getSize() === 'small') {
            // mobile photogallery for regular slideshow
            launchPhotoGalleries($('.fc-header .slide-list'), true, slideIndex);
            // mobile photogallery for type photogallery
            launchPhotoGalleries($('.fc-header .slide-list-photogallery'), true, slideIndex);
            return '';
        }
        // desktop photogalleries
        launchPhotoGalleries($('.fc-header .slide-list-photogallery'), false, slideIndex);
    }

    if (backbutton === true) {
        $els.slick('slickGoTo', parseInt(slideIndex, 10) - 1);
        return false;
    }

    $els = createSlideshow('.fc-header .slide-list, .fc-header .caption-list', true, slideIndex);
}
